import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceQuantitativeCell from '@Components/Results/substances/tables/quantitative/substance-quantitative-cell.component';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';
import { HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME } from '@Pages/Heatmap/HeatmapCellDetailsDialog/constants';
import { CITATION_LINKS_TRACKING_INDEX_MARKER } from '@Components/Results/analytics/citationLinksTracking';

export default class SubstanceQuantitativeTable extends React.PureComponent {
  render() {
    const { metadata, data, uniqueId, showAllNonEmptyCols } = this.props;
    const scrollContainerSelector = metadata.heatmapMode ? `.${HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME}` : null;

    return (
      <>
        <style>{ReactTableColumnSwitcherHelper.generateCssRules(uniqueId, data.headers)}</style>
        <table
          className={`rx-table rx-table--quantitative sticky-table-header ${ReactTableColumnSwitcherHelper.getTableClass(
            uniqueId,
            data.headers
          )}`}>
          <StickyTableHeaderComponent
            headers={data.headers}
            scrollContainerSelector={scrollContainerSelector}
            showAllNonEmptyCols={showAllNonEmptyCols}
          />
          <tbody>
            {data?.rows?.map((row, rowIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={rowIndex} {...CITATION_LINKS_TRACKING_INDEX_MARKER.substancesTableItem}>
                {data?.headers?.map((header, headerIndex) => (
                  <SubstanceQuantitativeCell
                    metadata={metadata}
                    header={header}
                    data={row?.cells?.[headerIndex]?.value}
                    measurements={row?.cells?.[headerIndex]?.measurements}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${rowIndex}-${headerIndex}`}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  }
}

SubstanceQuantitativeTable.propTypes = {
  metadata: MetadataPropTypesShape,
  data: PropTypes.object.isRequired,
  uniqueId: PropTypes.string.isRequired,
  showAllNonEmptyCols: PropTypes.func.isRequired,
};
